export default __webpack_public_path__ + "static/media/super_pokeball.5aa3873f.webp";